import { render } from "./FormSchemes.vue?vue&type=template&id=23c30cc2&scoped=true&ts=true"
import script from "./FormSchemes.vue?vue&type=script&lang=ts"
export * from "./FormSchemes.vue?vue&type=script&lang=ts"

import "./FormSchemes.vue?vue&type=style&index=0&id=23c30cc2&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c30cc2"]])

export default __exports__